import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import api from "../../../api/api";
import { CONFIRM_LAST_FOUR } from "../../../api/queryKeys";

export default function useConfirmDebitLastFour() {
  return useMutation<any, AxiosError, { cardId: number; last4: string }>(
    ({ cardId, last4 }) =>
      api.patch(`${CONFIRM_LAST_FOUR}${cardId}/`, { last4 })
  );
}
